var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.fieldName
    ? _c("DocumentIconComponent", {
        staticClass: "icon-component",
        attrs: { fileName: _vm.fieldName },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }